<fibra-modal-sem-adesao *ngIf="showModal"
[title]="'Acesso Negado'" [message]="'O master da sua empresa precisa aderir ao DDA'" [typeMessage]="'error'"
></fibra-modal-sem-adesao>